<template>
  <a-modal
    :title="title === '1' ? $t('add') : $t('edit')"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('close')"
    wrapClassName="ant-modal-cust-warp"
    style="top:5%;overflow-y: hidden">

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'id')" v-if='title === "2"'>
          <a-input  v-decorator="[ 'id', validatorRules.id]" :disabled='disabled'/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'type')">
          <a-select v-decorator="[ 'types', validatorRules.types]" :placeholder="$t('select') + ' ' + $t(I18N_KEY + 'type')" mode="multiple">
            <a-select-option v-for='item in telemarketTypes' :key='item.value'>
              {{item[fieldName]}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t(I18N_KEY + 'typeConfigNum')">
          <a-input :placeholder="$t('enter') + ' ' + $t(I18N_KEY + 'typeConfigNum')" v-decorator="[ 'num', validatorRules.num]" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'
const I18N_KEY = 'teleMarket.';
export default {
  name: "TeleMarketUserGroupTypeConfigEdit",
  props: {
    telemarketTypes: {
      type: Array,
      default: () => [],
    },
    groupId: {
      type: [String, Number],
      default: undefined,
    },
    fieldName:{
      type: String,
      default: 'textCn',
    }
  },
  data () {
    return {
      I18N_KEY,
      title:"Action",
      visible: false,
      disabled: true,
      // preType: '',
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules:{
        id:{
          rules: [
            { required: false, message: 'Please input id!' },
          ]},
        types:{
          rules: [
            { required: true, message: 'Please select types!' },
          ]},
        num:{
          rules: [
            { required: true, message: 'Please input a number greater than 0!', pattern: /^[1-9][0-9]*$/ },
          ]},
      },
    }
  },
  created () {
  },
  methods: {
    add () {
      this.edit({});
    },
    edit (record) {
      this.form.resetFields();
      this.open();
      this.model = Object.assign({}, record)
      this.model = {
        ...this.model
      }
      // this.preType = record.type
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model,'id','types', 'num'))
      });

    },
    open () {
      this.visible = true;
    },
    close () {
      this.$emit('close');
      this.visible = false;
    },
    openLoading () {
      this.confirmLoading = true;
    },
    closeLoading () {
      this.confirmLoading = false;
    },
    handleOk () {
      // console.log(88888)
      const that = this;
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let formData = {
            ...values,
          }
          // if(this.title === '2' && this.preType != '' && this.preType != formData.type) {
          //   that.confirmLoading = false;
          //   this.$message.error("This type cannot be modified");
          //   return
          // }
          this.$emit('ok', formData);

        }
      })
    },
    handleCancel () {
      this.close()
    },
  }
}
</script>

<style scoped>

</style>